import * as React from "react";
import { Button, Dialog, Checkbox, FormGroup, FormControlLabel, CircularProgress, Grid, DialogContent, DialogActions, DialogTitle, useTheme, } from "@material-ui/core";
import { useChangeTracksGenres } from "../model/use-tracks-genres";
export var GenreEditDialog = function (_a) {
    var checkedTracksIds = _a.checkedTracksIds, initialGenreIds = _a.initialGenreIds, isOpen = _a.isOpen, close = _a.close;
    var theme = useTheme();
    var dialogButtonStyle = theme.palette.type === "dark"
        ? { color: "#fff", borderColor: "rgba(255,255,255,0.7)" }
        : undefined;
    var _b = useChangeTracksGenres({
        checkedTracksIds: checkedTracksIds,
        initialGenreIds: initialGenreIds,
    }), genres = _b.genres, toggleById = _b.toggleById, updateTracksGenres = _b.updateTracksGenres, resetUpdateState = _b.resetUpdateState, isUpdating = _b.isUpdating, isSuccess = _b.isSuccess;
    var wasUpdatingRef = React.useRef(false);
    React.useEffect(function () {
        if (isUpdating) {
            wasUpdatingRef.current = true;
            return;
        }
        if (wasUpdatingRef.current && isSuccess) {
            wasUpdatingRef.current = false;
            close();
            resetUpdateState();
        }
    }, [close, isSuccess, isUpdating, resetUpdateState]);
    var handleClose = function () {
        wasUpdatingRef.current = false;
        close();
        resetUpdateState();
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: handleClose, maxWidth: "md" },
        React.createElement(DialogTitle, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0436\u0430\u043D\u0440\u044B"),
        React.createElement(DialogContent, null,
            genres ? (React.createElement(Grid, { container: true, spacing: 2 }, genres.map(function (genre) { return (React.createElement(Grid, { key: genre.id, item: true, xs: 3 },
                React.createElement(FormGroup, null,
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: genre.isChecked, onChange: function () { return toggleById(genre.id); }, name: "published", color: "primary" }), label: genre.title })))); }))) : (React.createElement(CircularProgress, null)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { color: "primary", variant: "outlined", style: dialogButtonStyle, onClick: handleClose }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { color: "primary", variant: "outlined", style: dialogButtonStyle, onClick: updateTracksGenres, disabled: isUpdating }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C")))));
};
